import eventOrganizerGuard from "@/utils/auth/eventOrganizerGuard";

export default [
  {
    path: "/series/:seriesId/event-edit/:eventId",
    name: "EventEdit",
    beforeEnter: eventOrganizerGuard,
    component: () => import("@/screens/eventEdit/EventEdit.vue")
  },
  {
    path: "/online-events",
    name: "OnlineEventDiscovery",
    component: () => import("@/screens/eventDiscovery/OnlineEventDiscovery.vue"),
    props: route => ({
      selectedDate: route.query.selectedDate || null
    })
  }
];
